import { render } from "./MobileMenu.vue?vue&type=template&id=51821cde&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=51821cde&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51821cde"
/* hot reload */
if (module.hot) {
  script.__hmrId = "51821cde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51821cde', script)) {
    api.reload('51821cde', script)
  }
  
  module.hot.accept("./MobileMenu.vue?vue&type=template&id=51821cde&scoped=true", () => {
    api.rerender('51821cde', render)
  })

}

script.__file = "src/components/menu/MobileMenu.vue"

export default script